import { FC } from 'react'
import { IBusinessLabel } from '../../model/labels'
import classes from './labels.module.scss'

export const LabelBadge: FC<{label: IBusinessLabel}> = ({label}) => {
    const rawLabel = label as IBusinessLabel & {backgroundColor?: string; textColor?: string}
    return <span
    className={classes.badge}
    style={{backgroundColor: rawLabel.background_color || rawLabel.backgroundColor, color: rawLabel.text_color || rawLabel.textColor}}
>{label.text}</span>
}
